var cartAdd = function(){
    var scope = ".js-cart-add";
    ui.ready(
        scope,
        function($cartAdd){
            var $quantity = $cartAdd.find(scope+"__qty");
            var $input = $cartAdd.find(scope+"__qty-input");
            var $moreButton = $cartAdd.find(scope+"__qty-more");
            var $lessButton = $cartAdd.find(scope+"__qty-less");

            function setProductQuantity(quantity,noEvent){
                $input.val(quantity);
                if(!noEvent){
                    $cartAdd.trigger("web:cartAddQuantityUpdate",{"quantity":quantity});
                    triggerAddToCartEvent();
                }
            }

            function refreshQuantity(){
                var quantity = parseInt($input.val());
                $cartAdd.find(scope+"__txt-1").toggle(quantity==1);
                $cartAdd.find(scope+"__txt-n").toggle(quantity>1);
                $quantity.html(quantity+" ");
            }

            function triggerAddToCartEvent(){
                if($cartAdd.data("is-pro-env")){
                    var item = {
                        item_name: $cartAdd.data("product-name"),
                        item_id: $cartAdd.data("product-id"),
                        price: $cartAdd.data("product-price"),
                        item_category: $cartAdd.data("product-category-name"),
                        quantity: parseInt($input.val())
                    };
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            items: [item]
                        }
                    });
                    console.log("triggerAddToCartEvent - cartAdd",item);
                } else {
                    console.log("triggerAddToCartEvent - cartAdd (not enabled in this environment)");
                }
            }

            $cartAdd.data("refreshQuantity",refreshQuantity);

            $moreButton.click(
                function(ev){
                    ev.preventDefault();
                    var newQuantity = parseInt($input.val())+1;
                    setProductQuantity(newQuantity);
                }
            );

            $lessButton.click(
                function(ev){
                    ev.preventDefault();
                    var newQuantity = parseInt($input.val())-1;
                    setProductQuantity(newQuantity);
                }
            );

            $input.keyup(
                function(ev){
                    ev.preventDefault();
                    var quantity = $(this).val();
                    if(!isNaN(quantity) && quantity==parseInt(quantity)){
                        setProductQuantity(quantity);
                    }
                }
            );

            $("body").on(
                "web:cartQuantityUpdate",
                function(ev,data){
                    gvf.delay(
                        100,
                        function(){
                            if(data.product_id==$cartAdd.data("product-id")){
                                setProductQuantity(data.quantity,true);
                                refreshQuantity();
                            }
                        }
                    );
                }
            );

            refreshQuantity();
        }
    );

    jQuery.fn.extend(
        {
            "getQuantity":function(){
                if(this.is(scope)){
                    return parseInt(this.find(scope+"__qty-input").val());
                }
                return undefined;
            }
        }
    );
}();